import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=2584faa4&scoped=true&"
import script from "./Edit.vue?vue&type=script&setup=true&lang=js&"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Edit.vue?vue&type=style&index=1&id=2584faa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584faa4",
  null
  
)

export default component.exports